import { EcmPartsService } from '../ecm-parts.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { EcmService } from '../../../ecm.service';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ecm-parts-part',
  templateUrl: './ecm-parts-part.component.html',
  styleUrls: ['./ecm-parts-part.component.scss']
})
export class EcmPartsPartComponent implements OnInit {

  partId: number;

  programs: any[] = [];
  partTypes: any[] = [];
  partTypeValue: any;

  partForm = new UntypedFormGroup({
    partNumber: new UntypedFormControl(null, [Validators.required, Validators.maxLength(8)]),
    partTypeId: new UntypedFormControl(null, [Validators.required]),
    program: new UntypedFormControl(null, [Validators.required]),
    partName: new UntypedFormControl(null, [Validators.required, Validators.maxLength(200)]),
    oppositePart: new UntypedFormControl(null, [Validators.maxLength(8)]),
    rL: new UntypedFormControl(null, [Validators.required]),
    lhStablePartCode: new UntypedFormControl(null, [Validators.maxLength(12)]),
    rhStablePartCode: new UntypedFormControl(null, [Validators.maxLength(12)]),
    dA: new UntypedFormControl(null, [Validators.required])
  });

  constructor(
    private readonly dialogRef: MatDialogRef<EcmPartsPartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly ecmService: EcmService,
    private readonly ecmPartsService: EcmPartsService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    this.partId = this.data.partId;

    // Populate form controls
    for (const [key, value] of Object.entries(this.data || {})) {
      const control: AbstractControl = this.partForm.get(key);
      if (value !== null && control) {
        control.setValue(value);
        control.markAsTouched();
      }
    }

    this.ecmService.getAllPrograms()
      .subscribe(data => this.programs = data);

    this.ecmPartsService.getPartTypes()
      .subscribe(response => {
        this.partTypes = response;
      });
  }

  toastrMessage() {
    this.toastr.error(`This part number, file type, LH CSPC and RH CSPC already exists. Therefore it will not be added.`);
  }

  private partAlreadyExists(body: any) {
    if (this.data.some(s => (s.partNumber === body.partNumber && s.partType === this.partTypeValue) &&
      (s.lhStablePartCode === body.lhStablePartCode && s.rhStablePartCode === body.rhStablePartCode))) {
      this.toastrMessage();
      return true;
    }

    if (this.data.some(s => (s.partNumber === body.partNumber && s.partType === this.partTypeValue) &&
      ((body.lhStablePartCode === null || body.lhStablePartCode === '') && body.rhStablePartCode === null))) {
      this.toastrMessage();
      return true;
    }

    if (this.data.some(s => (s.partNumber === body.partNumber && s.partType === this.partTypeValue) &&
      (s.lhStablePartCode === body.lhStablePartCode && body.rhStablePartCode === null))) {
      this.toastrMessage();
      return true;
    }

    if (this.data.some(s => (s.partNumber === body.partNumber && s.partType === this.partTypeValue) &&
      (s.rhStablePartCode === body.rhStablePartCode && (body.lhStablePartCode === null || body.lhStablePartCode === '')))) {
      this.toastrMessage();
      return true;
    }
    return false;
  }

  addPart(body: any) {
    if (this.partAlreadyExists(body)) {
      return;
    }

    else {
      body.partNumber = body.partNumber.toUpperCase();
      body.partName = body.partName.toUpperCase();

      if (body.oppositePart !== null) {
        body.oppositePart = body.oppositePart.toUpperCase();
      }
      if (body.lhStablePartCode !== null) {
        body.lhStablePartCode = body.lhStablePartCode.trim().length === 0 ? null : body.lhStablePartCode.toUpperCase();

      }
      if (body.rhStablePartCode !== null) {
        body.rhStablePartCode = body.rhStablePartCode.trim().length === 0 ? null : body.rhStablePartCode.toUpperCase();
      }

      this.ecmPartsService.addPart(body)
        .subscribe((response: any) => this.dialogRef.close(response));
    }

  }

  save() {
    if (!this.partForm.valid) {
      this.toastr.error('Missing required fields');
      return;
    }

    const body = this.partForm.value;
    body.partId = this.partId;
    this.addPart(body);
  }

  close() {
    this.dialogRef.close();
  }

  get hasEnabledFields(): boolean {
    const formData = this.partForm.value;
    return formData.partNumber && formData.partTypeId && formData.program && formData.partName
      && formData.rL && formData.dA;
  }

  getInnerText(innerText) {
    this.partTypeValue = innerText.partType;
  }
}
